// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Yo-z","tupacHeader":"Zo-z","tupacHeader2":"_o-z","tupacMenu":"ap-z","tupacMenu2":"bp-z","tupacMain":"cp-z","tupacMain2":"dp-z"};